<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="24">
          <a-col :md="5" :sm="24">
            <a-form-item  label="企业名称">
              <a-input v-model.trim="queryParam.enterpriseName"/>
            </a-form-item>
          </a-col>
          <a-col :span="19" :style="{ textAlign: 'right' }">
            <a-button type="primary" htmlType="submit"@click="$refs.table.refresh(true)">查询</a-button>
            <a-button style="margin-left: 8px;" @click="() => queryParam = {}">清空</a-button>
          </a-col>
        </a-row>

        <!--<span class="table-page-search-submitButtons">-->
          <!--<a-row type="flex" justify="space-between">-->
            <!--<a-col :span="15"></a-col>-->
            <!---->
          <!--</a-row>-->
        <!--</span>-->
        <!--    表格内容-->
        <s-table
          size="default"
          ref="table"
          rowKey="orderId"
          :columns="columns"
          :data="loadData"
          bordered
        >
      <span slot="action" slot-scope="text, record" style="white-space: nowrap;">
        <a v-if="configureEnabel"  @click="detailsView(record)">配置</a>
       <a-divider type="vertical" />
        <a   @click="doCopy(record.linkAddress)">复制</a>
       <a-divider type="vertical" v-if="editEnabel" />
        <a v-if="editEnabel"  @click="problemsDealing (record)">生成</a>
      </span>
          <span slot="qrCodeAddress" slot-scope="text,record">
          <a-popover v-if="record.linkAddress != null">
            <template slot="content" >
              <div style="overflow-y:auto;max-height:300px;padding-right: 0px">
                <div v-if="record.qrCodeAddress.length>30">
                  <img  width="200" height="200" :src="text"/>
                </div>
              </div>
            </template>
            <a type="primary">
             <div v-if="record.qrCodeAddress.length>30">
              <img  width="50" height="50" :src="text" alt=" 请生成图片"/>
             </div>
            </a>
          </a-popover>
          </span>

        </s-table>
      </a-form>
    </div>
    <a-modal v-model="dealingible"  title="配置" :width="600"  okText="确认" cancelText="取消" @ok="hideModal" :destroyOnClose="true" :confirmLoading="confirmLoading">
      <a-form :form="updateproblemform">
        <a-row>
          <a-col>
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="安装类别">
              <a-select  mode="multiple" @change="handleChangeItem" v-decorator="['installType', { rules: [{ required: true, message:'请选择安装类别!'}] }]">
                <a-select-option  v-for="type in installTypes" :key="type.code" >{{type.value}}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col>
            <a-form-item label="订单类型" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-select  v-decorator="['orderType', { rules: [{ required: true, message:'请选择订单类型!' }] }]" mode="multiple"  @blur="handleChangeType">
                <a-select-option v-for="item in List" :key="item.code" >{{item.value}}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col>
            <a-form-item label="下单提示内容" :labelCol="labelCol" :wrapperCol="wrapperCol">
               <a-textarea v-decorator="['popoutContent', { rules: [{ required: true, message:'请输入下单提示内容!' }] }]"/>
            </a-form-item>
          </a-col>
          <a-col>
            <a-form-item label="广告链接" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['skipAddress']"/>
            </a-form-item>
          </a-col>
          <a-col>
            <a-form-item label="服务电话" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input type="number" :minLength="8" :maxLength="11" v-decorator="['serveNum', { rules: [{ required: true, message:'请输入服务电话!' }] }]"/>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </a-modal>
  </a-card>
</template>

<script>
  // 调接口
  import {getList, getListModel, getSourceList} from '@/api/order/orderList'
  import {getPriceAuditlist,selectUsableInstallType} from '@/api/order/customerOrder'
  import {getselectCombox} from '@/api/order/NewlyaddedOrderList'
  import {customerModelSave,customerModelInsert,selectClientOrderInfo} from '@/api/enterprise/customerModel'
  import {getDictMap} from "../../utils/dict"
  import { STable } from '@/components'
  import { checkPermission } from '@/utils/permissions'
  import pick from 'lodash.pick'
  import moment from 'moment';
  import ATextarea from "ant-design-vue/es/input/TextArea";
  export default {
    name: "PartsOrder",
    components: {
      ATextarea,
      STable,
      // 注册弹框组件
    },
    data(){
      return{
        confirmLoading:false,
        findByDeptId:[],
        order_substate: [],
        defaultFileList: [
          {
            uid: '1',
            name: 'xxx.png',
            status: 'done',
            response: 'Server Error 500', // custom error message to show
            url: 'http://www.sas45454.com',
          },
          {
            uid: '2',
            name: 'yyy.png',
            status: 'done',
            url: 'http://www.qaz1212.com',
          },
        ],
        // 表头
        columns: [
          {
            title: '操作栏',
            dataIndex: 'action',
            scopedSlots: { customRender: 'action' },
            width:80,
          },
          {
            title: '企业名称',
            dataIndex: 'enterpriseName',
            align:'center'
          },
          {
            title: '二维码',
            dataIndex: 'qrCodeAddress',
            align:'center',
            scopedSlots: { customRender: 'qrCodeAddress' },
          },
          {
            title: '链接',
            dataIndex: 'linkAddress',
            align:'center'
          }
        ],
        loadData: parameter => {
          return getPriceAuditlist(Object.assign(parameter, this.queryParam))
          // getPriceAuditlist(this.queryParam.enterpriseName)
        },
        // 省
        selectAllProvince:[],
        // 市
        selectCityName:[],
        // 区
        selectAreaName:[],
        dtoList:[],
        // 字典为订单状态,
        order_status: [],
        // 字典为安装类型
        installTypes:[],
        List:[],
        orderList:[],
        // 企业名称
        selectCombox: [],
        getselectstoreList: [],
        dtoListtab:{},
        // queryParam:{enterpriseName:''},
        queryParam:{},
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 }
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 }
        },
        pendingMatterMenu:[],
        transferible:false,
        transferform: this.$form.createForm(this),
        dealingform: this.$form.createForm(this),
        resumeform: this.$form.createForm(this),
        updateproblemform: this.$form.createForm(this),
        replyproblemsform: this.$form.createForm(this),
        // 转派 表格
        ransfertrecord:'',
        pendingMattersRoleList:[],
        feedbackInfo:'',
        dealingible:false,
        updateproblemible:false,
        resumeible:false,
        deleteible:false,
        startProcessingible:false,
        processingCompletedible:false,
        appealProcessingible:false,
        detailsViewible:false,
        pendingMattersResume:[],
        message:'',
        enterpriseId:'',
        installTypeList:[],
        orderListType:'',
        typeList:[],
        mdl:'',
        clientOrderSetId:'',
        addEnable: checkPermission('customer:order:view'),
        editEnabel: checkPermission('customer:order:create'),
        configureEnabel: checkPermission('order:configureOrder:view'),
      }
    },
    // destroyed () {
    //   document.body.removeEventListener('keyup', e => {})
    // },
    async created () {
      if(!this.addEnable){
        var newarry=[]
        var titlearry=['二维码', '链接']
        for(let i in this.columns){
          if(titlearry.indexOf(this.columns[i].title)==-1){
            newarry.push(this.columns[i])
          }
        }
        this.columns=newarry
        cosole.log(this.columns)
      }
      // 订单子状态
      this.order_substate = [];
      this.restaurantOperTypeMap = await getDictMap('order_substate');
      this.restaurantOperTypeMap.forEach((value, key) => {
        // console.log(value,key)
        this.order_substate.push({code: key, label: value})
        // console.log(this.restaurantTypes)
      })




      // 字典为订单状态
      this.order_status = [];
      this.restaurantOperTypeMap = await getDictMap('order_status');
      this.restaurantOperTypeMap.forEach((value, key) => {
        this.order_status.push({code: key, label: value})
      })
      console.log(this.order_status)


      // 字典为安装类型
      // this.installTypes = [];
      // this.restaurantOperTypeMap = await getDictMap('install_type');
      // this.restaurantOperTypeMap.forEach((value, key) => {
      //   // console.log(value,key)
      //   this.installTypes.push({code: key, label: value})
      // })
      // console.log(this.installTypes)
    },
    methods:{
      SetOptionTitle(){
        var selects = document.getElementsByTagName("select");
        if (selects.length > 0) {
          for (var i = 0; i < selects.length; i++) {
            var options = selects[i].options;
            if (selects[i].options.length > 0) {
              for (var j = 0; j < options.length; j++) {
                if (options[j].title == "")
                  options[j].title = options[j].text;
              }
            }
          }
        }
      },
      handleChangeType(value){
        // console.log(value)
      },
      handleChangeItem(value){
        // console.log(value,)
        // console.log(this.orderList)
        this.updateproblemform.setFieldsValue({'orderType':undefined})
        this.List=[]
        for(let i=0;i<value.length;i++){
          // console.log(value[i])
          if(this.orderList.hasOwnProperty(value[i])){
            for(let a of this.orderList[value[i]]){
              this.List.push(a)
            }
          }
        }
        // console.log(this.List)
      },
      hideModal(){
        this.updateproblemform.validateFields((err, values) => {
          console.log(values)
          console.log(this.orderListType)
          if (!err) {
            this.confirmLoading=true
            var allData={}
            allData.enterpriseId=this.enterpriseId
            allData.skipAddress=values.skipAddress
            allData.popoutContent=values.popoutContent
            allData.serveNum=values.serveNum
            allData.installTypeList=values.installType
            allData.orderTypeList=values.orderType
            console.log(allData)
                if(this.clientOrderSetId==''){
                  allData.clientOrderSetId=''
                }else{
                  allData.clientOrderSetId=this.clientOrderSetId
                }
              customerModelSave(allData).then(res=>{
                console.log(res)
                this.confirmLoading=false
                if (res.code === 0){
                  this.dealingible=false
                  this.$message.success('保存成功');
                }else {
                  this.$message.error(res.msg);
                }
              })



          }})
      },
      problemsDealing(record){
        customerModelInsert({enterpriseId:record.enterpriseId}).then(res=>{
          console.log(res)
          this.$message.success(res.msg);
          this.$refs.table.refresh()
        })
      },
      filterOption(input, option) {
        return (
          option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
        );
      },
      detailsView(record){
        let that = this
        this.dealingible=true
        this.clientOrderSetId=[]
        this.List = []
        this.orderList = []
        console.log(record)
        this.enterpriseId=record.enterpriseId
        this.$nextTick(()=>{
          selectUsableInstallType({enterpriseId:that.enterpriseId}).then(res=>{
            console.log('peizhi',res.data)
            if(res.data != null){
              that.installTypes = res.data.installType
              that.orderList = res.data.orderType
              selectClientOrderInfo({enterpriseId:that.enterpriseId}).then(res=>{
                console.log(res.data)
                if(res.data){
                  for(let i=0;i<res.data.installType.length;i++){
                    // console.log(value[i])
                    if(that.orderList.hasOwnProperty(res.data.installType[i])){
                      for(let a of this.orderList[res.data.installType[i]]){
                        that.List.push(a)
                      }
                    }
                  }
                  that.clientOrderSetId=res.data.clientOrderSetId
                  that.mdl = res.data
                  let typeList=[]
                  that.updateproblemform.setFieldsValue(pick(that.mdl, 'popoutContent','serveNum','skipAddress','installType','orderType'))
                }
              })
            }else{
              that.installTypes = []
              that.orderList = []
            }
          })
        })
      },
      changechoose(e){
         console.log(e)
        this.installTypeList=[e]
        this.List = [];
        getList(e).then(res => {
          if (res.code === 0) {
            this.List = res.rows;
            console.log(res.rows)
          } else {
            this.$message.error(res.msg);
          }
        })
      },

      doCopy: function (val) {
        var that=this
        this.$copyText(val).then(function (e) {
          console.log(e)
          that.$message.success('复制成功')
        }, function (e) {
          console.log(e)
          that.$message.error('复制失败')
        })
      }


    }


  }
</script>

<style scoped>
  /deep/ .ant-table th { white-space: nowrap; }
  /deep/ .ant-table td { white-space: nowrap; padding: 6px 16px;}
</style>